<template lang="html">
  <div>
    <VqModal
      :name="modalName"
      class="vq-modal-add-pool">
      <template v-slot:header>
        <h2 class="modal-title">{{title}} <span class="is-bold">{{ $t('components.modalEditPool.pool') }}</span></h2>
        <button
          type="button"
          class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
          v-on:click="close">
          <span class="css-icon is-close"></span>
        </button>
      </template>
      <template v-slot:content>
        <div class="forms">
          <form>
            <div class="container has-separator">
              <div class="row">
                <VqSelect
                  classes="col-tab-4 pb-10"
                  name="host"
                  :label="$t('components.modalEditVm.form.site')"
                  option-label-attr="name"
                  option-value-attr="host"
                  :placeholder="$t('components.modalEditVm.form.siteP')"
                  :read-only="context=='update'"
                  :options="hostOptions"
                  :tooltip="c('add_pool:dc')"
                  :errors="errors.host"
                  v-model="formData.host"
                />
                <VqInput
                  classes="col-tab-8 pb-20"
                  :label="$t('components.modalEditPool.form.name')"
                  name="Name"
                  :tooltip="c('add_pool:name')"
                  type="text"
                  :errors="errors.name"
                  :min="0"
                  v-model="formData.name"
                />
                <VqInput
                  classes="col-tab-3 pb-20"
                  :label="$t('components.modalEditPool.form.vcpu')"
                  name="vcpu"
                  :tooltip="c('add_pool:vcpu')"
                  type="number"
                  :information="`${$t('components.modalEditPool.form.max')} ${max_vcpu_pool} ${$t('components.modalEditPool.form.ghz')}`"
                  :errors="errors.vcpu"
                  :min="0"
                  v-model="formData.vcpu"
                />
                <VqInput
                  classes="col-tab-3 pb-20"
                  :label="$t('components.modalEditPool.form.vram')"
                  name="vram"
                  :tooltip="c('add_pool:vram')"
                  type="number"
                  :information="`${$t('components.modalEditPool.form.max')} ${max_vram_pool} ${$t('components.modalEditPool.form.gb')}`"
                  :errors="errors.vram"
                  :min="0"
                  v-model="formData.vram"
                />
                <VqToggleBtn
                  classes="col-tab-3"
                  name="aa_option"
                  :label="$t('components.modalEditPool.form.aa')"
                  :option-true="$t('components.modalEditPool.form.on')"
                  :option-false="$t('components.modalEditPool.form.off')"
                  v-model="formData.aa_option"
                  :tooltip="c('add_pool:aa_option')"
                />
                <VqRadio
                  v-if="context!=='update'"
                  class="tab:2-columns pt-20 col-tab-6"
                  :label="$t('components.modalEditPool.form.edge')"
                  :columns="2"
                  :options="radioOptions"
                  :default="radioDefault"
                  name="createEdge"
                  :tooltip="c('add_pool:create_edge')"
                  :model.sync="radioData"
                />
              </div>
            </div>
            <div class="container has-separator">
              <div class="row">
                <div class="vq-repeater col-12">
                  <div class="field-wrapper">
                    <button
                      v-if="formData.disks && formData.disks.length < 3"
                      class="button is-small add-btn mb-20"
                      v-on:click.prevent="addDisk()">
                      {{ $t('components.modalEditPool.addStorage') }}
                    </button>
                    <template v-for="(disk, index) in formData.disks">
                      <div class="repeater-row mb-20" :key="index">
                        <h2 class="title-row" style="flex-basis:100%;">{{ $t('components.modalEditPool.storageProfile') }} {{index + 1}}</h2>
                        <div class="repeater-wrapper">
                          <VqInput
                            :label="$t('components.modalEditPool.form.storage')"
                            :name="'storage_' + index"
                            :tooltip="c('add_pool:disk_capacity')"
                            type="number"
                            :information="`${$t('components.modalEditPool.form.max')} ${max_storage_disk_pool} ${$t('components.modalEditPool.form.gb')}`"
                            :errors="errors.disks[index].capacity"
                            :min="0"
                            v-model="disk.capacity"
                          />
                          <VqSelect
                            :name="'classe_' + index"
                            :label="$t('components.modalEditPool.form.class')"
                            option-label-attr="label"
                            option-value-attr="value"
                            :options="diskOptions"
                            v-model="disk.classe"
                            :tooltip="c('add_pool:class')"
                          />
                          <div class="delete-row">
                            <button
                              class="icon icon-delete-inverse"
                              v-if="formData.disks.length > 1"
                              v-on:click="removeDisk(index)"
                            ></button>
                          </div>
                        </div>
                      </div>
                    </template>

                  </div>
                </div>
              </div>
            </div>
            <div class="container has-separator">
              <div class="row">
                <VqTextarea
                  classes="col-tab-12"
                  :label="$t('components.modalEditPool.form.comment')"
                  name="comment"
                  :tooltip="c('add_vm:comment')"
                  :errors="errors.comment"
                  v-model="formData.comment"
                />
              </div>
            </div>
            <div v-if="newPrice != null" class="container has-separator">
              <h2 class="modal-title is-bold p-5">{{ $t('components.modalEditPool.pricing') }}</h2>

              <table class="w-full total-table mt-10">
                  <thead>
                  <tr class="is-bold">
                    <th>{{ $t('components.modalEditPool.table.resources') }}</th>
                    <th>{{ $t('components.modalEditPool.table.qty') }}</th>
                    <th>{{ $t('components.modalEditPool.table.price') }}</th>
                    <th>{{ $t('components.modalEditPool.table.total') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                      <tr v-if="user.company_obj.director_pool_setup_fee && context === 'add'">
                          <td>{{ $t('components.modalEditPool.table.director_pool_setup_fee') }} :</td>
                          <td>1</td>
                          <td>{{user.company_obj.director_pool_setup_fee|price}}€</td>
                          <td>{{user.company_obj.director_pool_setup_fee|price}}€</td>
                      </tr>
                      <tr v-if="totalSetupFeeFromApi && context == 'add'" class="is-bold">
                        <td class="nowrap">{{ $t('components.modalEditVm.table.totalSetupFee') }} :</td>
                        <td></td>
                        <td></td>
                        <td>{{totalSetupFeeFromApi|price}}€</td>
                      </tr>
                      <tr v-if="formData.vcpu">
                          <td>{{ $t('components.modalEditPool.form.vcpu') }} :</td>
                          <td>{{formData.vcpu}}</td>
                          <td>{{user.company_obj.director_vcpu_price|price}}€</td>
                          <td>{{formData.vcpu * user.company_obj.director_vcpu_price|price}}€</td>
                      </tr>
                      <tr v-if="formData.vram">
                          <td>{{ $t('components.modalEditPool.form.vram') }} :</td>
                          <td>{{formData.vram}}{{ $t('components.modalEditPool.form.gb') }}</td>
                          <td>{{user.company_obj.director_vram_price|price}}€</td>
                          <td>{{formData.vram * user.company_obj.director_vram_price|price}}€</td>
                      </tr>
                      <tr v-if="formData.aa_option">
                          <td>{{ $t('components.modalEditPool.form.aa') }} :</td>
                          <td>1</td>
                          <td>{{aa_option_price|price}}€</td>
                          <td>{{aa_option_price|price}}€</td>
                      </tr>
                      <tr v-if="getClassStorageGb('gold')">
                          <td>{{ $t('components.modalEditPool.table.gold') }} :</td>
                          <td>{{getClassStorageGb('gold')}}{{ $t('components.modalEditPool.form.gb') }}</td>
                          <td>{{user.company_obj.director_gold_storage_price|price}}€</td>
                          <td>{{getClassStorageGb('gold') * user.company_obj.director_gold_storage_price|price}}€</td>
                      </tr>
                      <tr v-if="getClassStorageGb('silver')">
                          <td>{{ $t('components.modalEditPool.table.silver') }} :</td>
                          <td>{{getClassStorageGb('silver')}}{{ $t('components.modalEditPool.form.gb') }}</td>
                          <td>{{user.company_obj.director_silver_storage_price|price}}€</td>
                          <td>{{getClassStorageGb('silver') * user.company_obj.director_silver_storage_price|price}}€</td>
                      </tr>
                      <tr v-if="getClassStorageGb('bronze')">
                          <td>{{ $t('components.modalEditPool.table.bronze') }} :</td>
                          <td>{{getClassStorageGb('bronze')}}{{ $t('components.modalEditPool.form.gb') }}</td>
                          <td>{{user.company_obj.director_bronze_storage_price|price}}€</td>
                          <td>{{getClassStorageGb('bronze') * user.company_obj.director_bronze_storage_price|price}}€</td>
                      </tr>
                      <tr v-if="newPrice != null" class="is-bold">
                          <td>{{ $t('components.modalEditPool.table.totalVat') }} :</td>
                          <td></td>
                          <td></td>
                          <td>
                            <span v-if="priceLoadingVisible">...</span>
                            <template v-else>
                              {{newPrice|price}}€
                              <div class="mt-5" v-if="context === 'update'">
                                (<span v-if="(newPrice - oldPrice) >= 0">+</span>
                                {{(newPrice - oldPrice)|price}}€ )
                              </div>
                            </template>
                          </td>
                      </tr>
                  </tbody>
              </table>
            </div>
          </form>
        </div>
      </template>
      <template v-slot:footer>
        <button type="button" class="button is-small is-gray-400" v-on:click="close">{{ $t('components.modalEditPool.form.cancel') }}</button>
        <div>
          <button
            v-if="$store.state.display_edit && $store.state.otrs_is_active"
            :class="{'is-loading': loading}"
            type="button"
            class="button is-small is-gamma"
            @click="submit">{{title}} {{ $t('components.modalEditPool.pool') }}
          </button>
        </div>
      </template>
    </VqModal>
    <ModalVerificationCode
      v-if="isModalVerificationOpen"
      @verification-code="setVerification"
      @close-verification="closeVerification"/>
  </div>
</template>

<script lang="js">
import { mapGetters } from 'vuex';
import { eventHubMixin } from '@/mixins/event';

import DIRECTOR from '@/api/director';
import SUPPORT from '@/api/support';
import VqModal from '@/components/VqModal.vue';
import VqInput from '@/components/VqInput.vue';
import VqSelect from '@/components/VqSelect.vue';
import VqToggleBtn from '@/components/VqToggleBtn.vue';
import VqRadio from '@/components/VqRadio.vue';
import ModalVerificationCode from '@/components/ModalVerificationCode.vue';
import VqTextarea from '@/components/VqTextarea.vue';


export default {
  name: 'ModalAddEditPool',
  mixins: [eventHubMixin],
  components: {
    VqModal,
    VqInput,
    VqSelect,
    VqToggleBtn,
    VqRadio,
    ModalVerificationCode,
    VqTextarea,
  },
  data() {
    return {
      modalName: 'add-edit-pool',
      formData: {},
      errors: {},
      context: 'add',
      max_storage_disk_pool: null,
      max_vcpu_pool: null,
      max_vram_pool: null,
      diskOptions: [
        {
          label: this.$t('components.modalEditPool.config.silver'),
          value: 'silver',
        },
        {
          label: this.$t('components.modalEditPool.config.gold'),
          value: 'gold',
        },
      ],
      radioOptions: [
        {
          label: this.$t('components.modalEditPool.config.yes'),
          value: true,
        },
        {
          label: this.$t('components.modalEditPool.config.no'),
          value: false,
        },
      ],
      radioDefault: 'No',
      radioData: { value: false },
      isModalVerificationOpen: false,
      newPrice: null,
      oldPrice: 0,
      totalSetupFeeFromApi: 0,
      priceLoading: false,
      priceLoadingVisible: false,
      priceFetchTimeout: null,
      priceLoadingDelayTimeout: null,
      currentValues: {},
      hostOptions: [],
      loading: false,
    };
  },
  filters: {
    price(value) {
      return (value / 100).toFixed(2);
    },
  },

  watch: {
    formData: {
      handler() {
        if (this.priceFetchTimeout) clearTimeout(this.priceFetchTimeout);
        this.priceFetchTimeout = setTimeout(() => this.fetchPrice(), 300);
      },
      deep: true,
    },
    'radioData.value'(newValue) {
      if (newValue === false) {
        this.formData.ip_number = 0;
        delete this.formData.ip_number;
      }
    },
  },
  mounted() {
    this.onOpenModal(this.modalName, (data) => {
      DIRECTOR.listHosts().then((res) => {
        this.hostOptions = res.data;
        this.getMaxValues();
        if (data && Object.keys(data).length !== 0) {
          this.formData = JSON.parse(JSON.stringify(data));
          this.currentValues = JSON.parse(JSON.stringify(data));
          this.context = 'update';
        } else {
          this.initFormData();
          this.context = 'add';
        }
        this.initFormErrors();
        this.fetchPrice();
      });
    });
  },
  methods: {
    close() {
      this.emitCloseModal(this.modalName);
    },

    fetchPrice() {
      if (!this.user || !this.user.company_obj) return;
      const disks = (this.formData.disks || []).map(d => ({
        capacity: parseInt(d.capacity, 10) || 0,
        classe: d.classe || 'gold',
      }));
      const payload = {
        context: this.context === 'add' ? 'add' : 'edit',
        vcpu: parseInt(this.formData.vcpu, 10) || 0,
        vram: parseInt(this.formData.vram, 10) || 0,
        aa_option: !!this.formData.aa_option,
        disks,
      };
      if (this.context === 'update') {
        payload.current_vcpu = parseInt(this.currentValues.vcpu, 10) || 0;
        payload.current_vram = parseInt(this.currentValues.vram, 10) || 0;
        payload.current_aa_option = !!this.currentValues.aa_option;
        payload.current_disks = (this.currentValues.disks || []).map(d => ({
          capacity: parseInt(d.capacity, 10) || 0,
          classe: d.classe || 'gold',
        }));
      }
      if (this.priceLoadingDelayTimeout) clearTimeout(this.priceLoadingDelayTimeout);
      this.priceLoadingVisible = false;
      this.priceLoading = true;
      this.priceLoadingDelayTimeout = setTimeout(() => {
        this.priceLoadingVisible = true;
      }, 200);
      SUPPORT.calculatePoolPrice(payload)
        .then((res) => {
          this.newPrice = res.data.new_price;
          this.oldPrice = res.data.old_price;
          this.totalSetupFeeFromApi = res.data.total_setup_fee;
        })
        .catch(() => {
          this.newPrice = null;
          this.oldPrice = 0;
          this.totalSetupFeeFromApi = 0;
        })
        .finally(() => {
          if (this.priceLoadingDelayTimeout) {
            clearTimeout(this.priceLoadingDelayTimeout);
            this.priceLoadingDelayTimeout = null;
          }
          this.priceLoading = false;
          this.priceLoadingVisible = false;
        });
    },

    initFormData() {
      this.newPrice = null;
      this.oldPrice = 0;
      this.totalSetupFeeFromApi = 0;
      this.radioData.value = false;
      this.formData = {
        name: '',
        vcpu: '',
        vram: '',
        aa_option: false,
        disks: [
          {
            name: 'Storage Profile 1',
            capacity: 0,
            classe: this.diskOptions[0].value,
          },
        ],
        verification_code: '',
      };
    },

    initFormErrors() {
      this.errors = {
        name: [],
        vcpu: [],
        vram: [],
        disks: [],
        non_field_errors: [],
        verification_code: [],
        comment: [],
      };
      this.formData.disks.forEach(() => {
        this.errors.disks.push({
          capacity: [],
        });
      });
    },

    getMaxValues() {
      SUPPORT.maxValues().then((res) => {
        this.max_storage_disk_pool = res.data.max_storage_disk_pool;
        this.max_vcpu_pool = res.data.max_vcpu_pool;
        this.max_vram_pool = res.data.max_vram_pool;
      });
    },


    addDisk() {
      this.formData.disks.push({
        name: `${'Storage Profile' + ' '}${this.formData.disks.length + 1}`,
        capacity: 0,
        classe: this.diskOptions[0].value,
      });
      this.errors.disks.push({ capacity: [] });
    },

    removeDisk(i) {
      this.formData.disks.splice(i, 1);
    },

    setVerification(data) {
      this.isModalVerificationOpen = false;
      this.formData.verification_code = data;
      this.submit();
    },
    sendVerificationCode() {
      this.loading = true;
      SUPPORT.verification_code().then((res) => {
        this.isModalVerificationOpen = true;
      }),
      (err) => {
        Object.assign(this.errors, err.response.data);
      };
    },

    submit() {
      // Prix calculés côté serveur - ne plus envoyer price/current_price/total_setup_fee
      this.formData.current_vcpu = this.currentValues.vcpu;
      this.formData.current_vram = this.currentValues.vram;
      this.formData.current_disks = this.currentValues.disks;
      this.formData.current_aa_option = this.currentValues.aa_option;
      this.formData.create_edge = this.radioData.value;
      const method = this.context === 'add' ? 'addPool' : 'editPool';
      this.initFormErrors();
      SUPPORT[method](this.formData).then(() => {
        this.loading = false;
        this.initFormData();
        this.initFormErrors();
        this.close();
        this.addToast();
      },
      (err) => {
        this.loading = false;
        Object.assign(this.errors, err.response.data);
        this.formData.verification_code = '';
        if (Object.keys(err.response.data).toString() === ['verification_code'].toString()) {
          this.sendVerificationCode();
        }
        if (err.response.status === 500) {
          this.emitAddToaster({
            title: this.$t('components.modalEditPool.toasts.ticketError'),
            text: this.$t('components.modalEditPool.toasts.ticketErrorContent'),
            state: 'danger',
          });
          this.close();
        }
      });
    },

    addToast() {
      this.emitAddToaster({
        title: this.$t('components.modalEditPool.toasts.title'),
        text: this.$t('components.modalEditPool.toasts.content'),
        state: 'success',
        // link: 'http://telecloud.fr'
      });
    },

    getClassStorageGb(classe) {
      if (this.formData.disks) {
        const sumOfGb = this.formData.disks.filter(disk => disk.classe === classe).reduce((sum, currentValue) => sum + parseInt(currentValue.capacity), null);
        if (sumOfGb) {
          return sumOfGb;
        }
      }
      return 0;
    },

    closeVerification() {
      this.isModalVerificationOpen = false;
      this.loading = false;
    },


  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
    title() {
      if (this.context === 'add') {
        return this.$t('components.modalEditPool.config.add');
      }
      return this.$t('components.modalEditPool.config.edit');
    },
    aa_option_price() {
      const aaOptionPrice = this.formData.aa_option ? this.user.company_obj.director_aa_option_price : 0;
      if (!aaOptionPrice || this.newPrice == null) return 0;
      return this.newPrice - this.newPrice / (1 + aaOptionPrice / 100);
    },
  },
};
</script>

<style scoped lang="scss">
.total-table {
  th {
    text-align: left;
  }
  td, th {
    padding: 5px;
  }
}
</style>
